export const AWS_ARN_FOR_WELL_ARCHITECTED =
  "(^arn:aws:wellarchitected:[a-zA-Z0-9-:/_]{20,})";
